import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@repo/ui/dialog'
import { useT } from '@repo/ui/hooks'

import { beneficiaryInsightsActions as actions } from '@/store/beneficiary-insights/slice'
import { useStoreDispatch, useStoreState } from '@/store/hooks'

import { Card } from '../cards/Card'

export function InsightWidgetShowDialog() {
  const { t } = useT({ keyPrefix: 'admin.insights.list.dialog' })
  const dispatch = useStoreDispatch()

  const open = useStoreState((state) => state.beneficiaryInsights.showDialog)
  const widget = useStoreState((state) => state.beneficiaryInsights.selectedComputedWidget)

  return (
    <Dialog open={open} onOpenChange={() => dispatch(actions.closeWidgetDialog())}>
      <DialogContent size={widget?.type === 'chart' ? `wide` : 'default'}>
        <DialogHeader>
          <DialogTitle>{t('title')}</DialogTitle>
          <DialogDescription></DialogDescription>
        </DialogHeader>
        {widget && <Card widget={widget} />}
      </DialogContent>
    </Dialog>
  )
}
